<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 md-layout" v-if="this.data.length">
      <div
        class="md-layout-item md-size-100 p-0"
        v-for="(item, index) in data"
        :key="index + 'chart'"
      >
        <DetailChart
          :pieChartData="item.chartData"
          :option="item.option"
          :index="index"
        ></DetailChart>
      </div>
    </div>
    <div class="md-layout-item md-size-100" v-else>
      <div class="md-card">
        <div class="md-card-content"><NoDataFound></NoDataFound></div>
      </div>
    </div>
  </div>
</template>
<script>
import DetailChart from "./DetailChart";
import { service_paths } from "@/constants/Services";

export default {
  components: {
    DetailChart
  },
  data() {
    return {
      data: []
    };
  },
  created() {
    this.fetchSurveyReport();
  },

  computed: {
    surveyId() {
      return this.$route.params.id;
    }
  },
  methods: {
    fetchSurveyReport() {
      this.$axios
        .get(`${service_paths.report_surveys}/summarize`, {
          survey_id: this.surveyId
        })
        .then(res => {
          this.$emit("updateTitle", res.data.survey_title);
          if (res.data.answers.length) {
            this.data = res.data.answers.map(item => {
              return {
                option: {
                  is_require: item.is_require,
                  hasChoice: item.has_choice,
                  questionText: item.title,
                  responses: item.count_answer
                },
                chartData: {
                  percent_chart: item.percent_chart,
                  data: item.data,
                  label: item.label
                }
              };
            });
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>
